import { SlateNode } from '@all-hands-hq/plex-graphql-schema';

import { LinkPreviewMetadataFragment, MentionsPlexRegisteredUserFragment } from '../../../graphql/gen/types';
import { getLinkData } from '../../../utils/links';

function slateNodeToStringArray(
  node: SlateNode,
  emailsToNames: Record<string, string>,
  linksToTitles: Record<string, string>
): string[] {
  if (node.text) {
    return [node.text];
  } else if (node.type === 'mention' && emailsToNames[node.email]) {
    return [`@${emailsToNames[node.email]}`];
  } else {
    const childrenText: string[] = [];
    node.children?.forEach((element: SlateNode) => {
      slateNodeToStringArray(element, emailsToNames, linksToTitles).forEach((t) => childrenText.push(t));
    });
    // Paragraphs should just have all their formated text concated
    // All other block types need newlines
    if (node.type === 'paragraph') {
      return [childrenText.join('')];
    } else if (node.type === 'expanded_link' && linksToTitles[node.url]) {
      return [linksToTitles[node.url]];
    } else if (node.type === 'bulleted-list') {
      return childrenText.map((childText) => `• ${childText}`);
    } else if (node.type === 'numbered-list') {
      return childrenText.map((childText, idx) => `${(node.startNumber || 1) + idx}. ${childText}`);
    } else {
      return childrenText;
    }
  }
}

export function plainTextPreview(
  nodes: SlateNode[],
  mentions: MentionsPlexRegisteredUserFragment[],
  links: LinkPreviewMetadataFragment[]
): string {
  // Accumulate a map from emails to names
  const emailsToNames = mentions.reduce((acc: Record<string, string>, m: { name?: string; email?: string }) => {
    if (m.email && m.name) acc[m.email] = m.name;
    return acc;
  }, {});

  // Accumulate a map from links to link titles
  const linksToTitles = links.reduce((acc: Record<string, string>, { id, details }) => {
    if (details.__typename !== 'ImageLinkMetadata') {
      const { title } = getLinkData(details);

      acc[id] = title || id;
    }

    return acc;
  }, {});

  const output: string[] = [];
  nodes.forEach((n) => {
    slateNodeToStringArray(n, emailsToNames, linksToTitles).forEach((t) => {
      output.push(t);
    });
  });
  return output.join('⏎ ');
}
